module.exports = __webpack_public_path__ + "static/media/1007827718.d0289dc0.jpg";